import { FC } from "react";
import { Flex } from "@smile2impress/components/relaunch";

import { ClinicCardProps } from "./ClinicCard.types";
import { ClinicCard } from "./ClinicCard";

export const ClinicCardColumn: FC<ClinicCardProps> = (props) => {
    return (
        <Flex
            width="100%"
            pb={1}
            height="100%"
            alignSelf="stretch"
            direction="column"
            justifyContent="space-between"
        >
            <ClinicCard {...props} />
        </Flex>
    );
};
